"use client";
import React, { useState, useEffect } from "react";
import "../styles/BlogStyles/BlogStyles.css";

const BlogPostDetail = () => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  // --- 1. CORRECT CONFIGURATION FOR WORDPRESS.COM ---
  
  // The domain of your site (without https://)
  const siteDomain = "hhari2804-cmqpl.wordpress.com";
  
  // The slug matches the last part of your URL: .../2025/11/28/hello-world/
  const postSlug = "hello-world"; 

  useEffect(() => {
    const fetchPost = async () => {
      try {
        // --- 2. UPDATED API URL FOR WORDPRESS.COM ---
        // We use public-api.wordpress.com to avoid CORS/Permission errors
        const response = await fetch(
          `https://public-api.wordpress.com/wp/v2/sites/${siteDomain}/posts?slug=${postSlug}&_embed`
        );
        
        const data = await response.json();
        
        if (data && data.length > 0) {
          setPost(data[0]);
        } else {
          console.log("Post not found in API response");
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching blog post:", error);
        setLoading(false);
      }
    };

    fetchPost();
  }, []);

  if (loading) {
    return <div className="text-center py-5">Loading article...</div>;
  }

  if (!post) {
    return <div className="text-center py-5">Post not found.</div>;
  }

  return (
    <article className="blog-detail-section py-5 bg-light">
      <div className="container bg-white p-4 p-lg-5 rounded shadow-sm">
        
        {/* 3. DYNAMIC FEATURED IMAGE */}
        {post._embedded && post._embedded["wp:featuredmedia"] && (
          <div className="mb-5 text-center">
            <img
              src={post._embedded["wp:featuredmedia"][0].source_url}
              alt={post.title.rendered}
              className="img-fluid rounded w-100 object-fit-cover"
              style={{ maxHeight: "700px" }}
            />
          </div>
        )}

        {/* 4. DYNAMIC TITLE */}
        <div className="text-center mb-5">
          <h1 
            className="fw-bold text-purple display-6"
            dangerouslySetInnerHTML={{ __html: post.title.rendered }}
          />
        </div>

        {/* 5. DYNAMIC CONTENT */}
        <div 
            className="blog-content text-secondary"
            dangerouslySetInnerHTML={{ __html: post.content.rendered }}
        />
        
      </div>
    </article>
  );
};

export default BlogPostDetail;